import { combineReducers, type Reducer } from "@reduxjs/toolkit";

import contentToPeopleAssignments from "../ContentAssignments/state/slices/contentAssignmentsSlice";
import contentAssignmentsFiltersSlice from "../ContentAssignments/state/slices/contentAssignmentsFiltersSlice";
import createRoleReducer from "../CreateRoles/state/createRoleReducer";
import { editRole } from "../EditRole/editRoleReducer";
import { addGroup } from "../Groups/AddGroup/state/addGroupReducer";
import { editGroup } from "../Groups/EditGroup/editGroupReducer";
import { groupsOverviewReducer } from "../Groups/GroupsOverview/state/groupsOverviewReducer";
import { enrollmentUsersReducer } from "../Groups/state/slices/enrollmentUsersSlice";
import { enrollmentCompaniesReducer } from "../Groups/state/slices/enrollmentCompaniesSlice";
import { GroupTemplateReducer } from "../GroupTemplate/state/reducer";
import rolesOverviewReducer from "../RolesOverview/state/rolesOverviewReducer";
import { type PeopleState, type UsersFilterOptions } from "../types";
import { addUserReducer } from "../Users/AddUser/state/addUserReducer";
import { editUserReducer } from "../Users/EditUser/state/editUserRootReducer";
import userCommonReducer from "../Users/state/userCommonReducer";
import { usersOverview } from "../Users/UsersOverview/state/usersOverviewReducer";
import addToContentModal from "./slices/addToContentSlice";
import ContentAssignmentSlice from "./slices/contentAssignmentSlice";
import ContentAssignmentFilterSlice from "./slices/contentAssignmentFilterSlice";
import withFilterOptions from "../../Application/reducers/hoc/withFilterOptions";
import ReducerNamespaceTypes from "../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../enums/reducer/reducerEntityPrefixTypes";

const peopleReducer = combineReducers({
  groupsOverview: groupsOverviewReducer,
  addUserReducer,
  editUser: editUserReducer,
  usersOverview,
  userCommon: userCommonReducer,
  addToContentModal,
  addGroup,
  createRole: createRoleReducer,
  editGroup,
  groupTemplate: GroupTemplateReducer,
  rolesOverview: rolesOverviewReducer,
  editRole,
  contentToPeople: combineReducers({
    assignments: contentToPeopleAssignments,
    filters: contentAssignmentsFiltersSlice,
  }),
  contentAssignment: combineReducers({
    content: ContentAssignmentSlice,
    filters: ContentAssignmentFilterSlice,
  }),
  enrollmentUsers: enrollmentUsersReducer,
  enrollmentCompanies: enrollmentCompaniesReducer,
  enrollmentFilterOptions: withFilterOptions<UsersFilterOptions>(
    ReducerNamespaceTypes.People,
    `${ReducerEntityPrefixTypes.Groups}__EnrollmentFilters`,
  ),
}) as unknown as Reducer<PeopleState>;

export default peopleReducer;

// NOSONAR TODO: resolve types from lower level reducers
// export type PeopleState = ReturnType<typeof peopleReducer>;
